/* kleurstaal-slidein.js */
(function () {
  const cfg = window.KS_SLIDEIN_CONFIG || {};

  // ---- Toggle (default: true)
  const enabled = cfg.enabled !== false;
  if (!enabled) return;

  // ---- Settings
  const delayMs = Number.isFinite(cfg.delayMs) ? cfg.delayMs : 30000; // e.g. 20000 for 20 sec
  const href = cfg.href || "/products/kleurenstaal";
  const sessionKey = cfg.sessionKey || "ks_slidein_shown_session"; // 1x per sessie
  const startKey = cfg.startKey || "ks_slidein_session_start";     // sessie start timestamp
  const mountId = cfg.mountId || "kleurstaal-slidein";

  // Optional: only show on certain paths
  if (Array.isArray(cfg.includePaths) && cfg.includePaths.length) {
    const ok = cfg.includePaths.some((rx) => rx instanceof RegExp && rx.test(location.pathname));
    if (!ok) return;
  }
  // Optional: exclude paths
  if (Array.isArray(cfg.excludePaths) && cfg.excludePaths.length) {
    const blocked = cfg.excludePaths.some((rx) => rx instanceof RegExp && rx.test(location.pathname));
    if (blocked) return;
  }

  // ---- Session guard (already shown)
  try {
    if (sessionStorage.getItem(sessionKey) === "1") return;
  } catch (e) {}

  // ---- Create DOM
  function create() {
    if (document.getElementById(mountId)) return;

    const el = document.createElement("div");
    el.id = mountId;
    el.className = "ks-slidein";
    el.setAttribute("aria-hidden", "true");
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-label", cfg.ariaLabel || "Kleurstaal aanvragen");

    el.innerHTML = `
      <button class="ks-close" type="button" aria-label="Sluiten">×</button>
      <div class="ks-content">
        <div class="ks-eyebrow">${cfg.eyebrow || "Twijfel over de kleur?"}</div>
        <div class="ks-title">${cfg.title || "Vraag een kleurstaal aan"}</div>
        <div class="ks-text">${cfg.text || "Bekijk de tint in het echt. Bij aankoop van een kunstwerk is je kleurstaal uiteindelijk gratis."}</div>
        <a class="ks-cta" href="${href}">${cfg.ctaText || "Bekijk kleuren →"}</a>
      </div>
    `;

    document.body.appendChild(el);

    // Events
    const closeBtn = el.querySelector(".ks-close");
    const close = () => {
      el.classList.remove("is-open");
      el.setAttribute("aria-hidden", "true");
    };
    closeBtn && closeBtn.addEventListener("click", close);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    return el;
  }

  function open(el) {
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    try { sessionStorage.setItem(sessionKey, "1"); } catch (e) {}
  }

  // ---- Session-based timer (counts across pages)
  let timerId = null;
  let el = null;

  function getSessionStart() {
    try {
      const raw = sessionStorage.getItem(startKey);
      if (raw) {
        const n = parseInt(raw, 10);
        if (Number.isFinite(n)) return n;
      }
      const now = Date.now();
      sessionStorage.setItem(startKey, String(now));
      return now;
    } catch (e) {
      // If sessionStorage fails, fallback to "page-based" start
      return Date.now();
    }
  }

  function getRemainingMs() {
    const startedAt = getSessionStart();
    const elapsed = Date.now() - startedAt;
    return Math.max(delayMs - elapsed, 0);
  }

  function scheduleOpen() {
    if (timerId) return;

    const remaining = getRemainingMs();

    timerId = window.setTimeout(() => {
      el = el || create();
      if (el) open(el);
    }, remaining);
  }

  function clearSchedule() {
    if (!timerId) return;
    clearTimeout(timerId);
    timerId = null;
  }

  // Pause/resume without resetting "session start"
  function onVisibility() {
    if (document.hidden) {
      clearSchedule();
    } else {
      // If already shown in the meantime, do nothing
      try {
        if (sessionStorage.getItem(sessionKey) === "1") return;
      } catch (e) {}
      scheduleOpen();
    }
  }

  document.addEventListener("visibilitychange", onVisibility);

  // Wait until DOM is ready for body append
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleOpen);
  } else {
    scheduleOpen();
  }
})();